import { render } from "./ModalTitular.vue?vue&type=template&id=aedeab5c&scoped=true"
import script from "./ModalTitular.vue?vue&type=script&lang=js"
export * from "./ModalTitular.vue?vue&type=script&lang=js"

import "./ModalTitular.vue?vue&type=style&index=0&id=aedeab5c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aedeab5c"]])

export default __exports__